var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAiReceptionistIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 509.36 509.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 254.68,
    y1: 510.79,
    x2: 254.68,
    y2: -0.08,
    gradientTransform: "translate(0 510.07) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0780af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d6183"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 509.36,
    height: 509.36,
    rx: 54.11,
    ry: 54.11,
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 282.5,
    width: 1.49,
    height: 0.99,
    style: {
      fill: "#0b7ba5"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M137.11,318.17c1.52,6.35,5.18,17.64,13.59,30.21,11.58,17.3,34.82,40.42,79.73,52.31.01,0,.02,0,.04,0-1.49-2.18-2.31-4.6-2.31-7.14,0-.26,0-.51.02-.76-63.42-18.27-79.85-59.03-83.89-74.62h-7.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.15,393.56c0,2.54.82,4.96,2.31,7.14,4.14,6.09,13.43,10.34,24.22,10.34,14.65,0,26.53-7.82,26.53-17.48s-11.88-17.48-26.53-17.48-25.9,7.42-26.5,16.72c-.02.25-.02.51-.02.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.46,226.85c2.16-.5,4.41-.77,6.72-.77h13.7c.72-60.79,47.46-110.01,104.81-110.01,57.35,0,104.09,49.22,104.81,110.01h13.7c2.31,0,4.56.27,6.72.77-.34-70.93-56.38-128.53-125.22-128.53s-124.89,57.6-125.22,128.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.67,288.69c0,1.21-.07,2.4-.21,3.58,7.67-2.72,13.22-10.71,13.22-20.14s-5.55-17.42-13.22-20.14c.14,1.17.21,2.37.21,3.58v33.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.9,226.08v92.1h15.29c15.08,0,27.51-11.31,29.27-25.91h0c.14-1.18.21-2.37.21-3.58v-33.12c0-1.21-.07-2.4-.21-3.58h0c-1.49-12.36-10.64-22.37-22.55-25.14-2.16-.5-4.41-.77-6.72-.77h-15.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.53,226.08v92.1h9.37v-92.1h-9.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.68,272.13c0,9.43,5.55,17.42,13.22,20.14-.14-1.17-.21-2.37-.21-3.58v-33.12c0-1.21.07-2.4.21-3.58-7.67,2.72-13.22,10.71-13.22,20.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.69,255.57v33.12c0,1.21.07,2.4.21,3.58,1.77,14.6,14.2,25.91,29.27,25.91h15.29v-92.1h-15.29c-2.31,0-4.56.27-6.72.77-11.92,2.78-21.06,12.78-22.56,25.14-.14,1.17-.21,2.37-.21,3.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.46,226.08v92.1h9.36v-92.1s-9.36,0-9.36,0Z",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiReceptionistIcon);
export default __webpack_public_path__ + "static/media/ai-receptionist-icon.bae3879cccf9c1044f0fc699076083cd.svg";
export { ForwardRef as ReactComponent };